module.exports = __webpack_public_path__ + "img/2.02a2e332.jpg";